import React from 'react';
import '../style/CouponCard.css';

const CouponCard = ({ store, logo, title, code, expires, onShowCode }) => {
  return (
    <div className="coupon-card">
      <img src={logo} alt={store} />
      <h3>{title}</h3>
      <p className="expires">{expires}</p>
      <button onClick={() => onShowCode(code)}>
        Show Code
      </button>
    </div>
  );
};

export default CouponCard;
